/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|themes|mattressfirm|views|components|addtocart|addtocart'] = {
                c: () => require('partner/themes/mattressfirm/views/components/addtocart/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|carticon'] = {
                c: () => require('partner/themes/mattressfirm/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|cartlineitem'] = {
                c: () => require('partner/themes/mattressfirm/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|delivery-message|deliverymessage'] = {
                c: () => require('partner/themes/mattressfirm/views/components/delivery-message/deliverymessage.component.tsx'),
                cn: '__local__-__local__-deliverymessage'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|price|price'] = {
                c: () => require('partner/themes/mattressfirm/views/components/price/price.component.tsx'),
                cn: '__local__-__local__-price'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|product'] = {
                c: () => require('partner/themes/mattressfirm/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|promocode'] = {
                c: () => require('partner/themes/mattressfirm/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|rating'] = {
                c: () => require('partner/themes/mattressfirm/views/components/rating.component.tsx'),
                cn: '__local__-__local__-rating'
            };
componentDictionary['__local__|__local__|themes|mattressfirm|views|components|selectable-card|selectable-card'] = {
                c: () => require('partner/themes/mattressfirm/views/components/selectable-card/selectable-card.component.tsx'),
                cn: '__local__-__local__-selectable-card'
            };